import { Outlet } from 'react-router-dom';

import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { NotIOsAppFeature } from '@sorare/core/src/components/BuyableFeature';

import { AppLayout } from '@sorare/us-sports/src/components/AppLayout';

import { DailyClaimButton } from 'components/rewards/DailyClaimButton';

const Layout = () => (
  <>
    <NotIOsAppFeature>
      <Portal id="page-header-right-button">
        <DailyClaimButton />
      </Portal>
    </NotIOsAppFeature>
    <AppLayout>
      <Outlet />
    </AppLayout>
  </>
);

export default Layout;
